import { getDepartmentId, getBonusMonth, getDistrictId, getMonthBonusState } from './selectors';
import { setMonthlyBonusApi } from './graphql/setAllUsersMonthlyBonusAmountApi';
import { setStateAllUserMonthBonusesSummaryApi } from './graphql/setFinalizedStateAllUsersBonuses';
import { massMonthlyBonusUpdaterApi } from './graphql/setUserMonthBonusMassUpdaterApi';

export const types = {
  SET_DEPARTMENT: 'bonusSummary/SET_DEPARTMENT',
  SET_DISTRICT: 'bonusSummary/SET_DISTRICT',
  SET_BONUS_MONTH: 'bonusSummary/SET_BONUS_MONTH',
  SET_MONTH_BONUS_STATE: 'bonusSummary/SET_MONTH_BONUS_STATE',
};

export const setBonusMonth = (monthDate) => {
  return {
    type: types.SET_BONUS_MONTH,
    bonusMonth: monthDate,
  };
};

export const setMonthBonusState = (monthBonusState) => {
  return {
    type: types.SET_MONTH_BONUS_STATE,
    monthBonusState,
  };
};

export const dispatchDistrict = (district) => {
  return {
    type: types.SET_DISTRICT,
    district,
  };
};

export const dispatchDepartment = (department) => {
  return {
    type: types.SET_DEPARTMENT,
    department,
  };
};

export const setUserMonthlyBonus = (userTicketBonusArray) => {
  return async (dispatch, getState, { client }) => {
    await setMonthlyBonusApi(client, userTicketBonusArray);
  };
};

export const setStateAllUserMonthBonuses = (allUserMonthBonusesId, setNextState) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const bonusMonth = getBonusMonth(state);
    const districtId = getDistrictId(state);
    const departmentId = getDepartmentId(state);
    const monthBonusState = getMonthBonusState(state);

    await setStateAllUserMonthBonusesSummaryApi(
      client,
      allUserMonthBonusesId,
      setNextState,
      bonusMonth,
      districtId,
      departmentId,
      monthBonusState,
    );
  };
};

export const setMassUserMonthBonusUpdater = (finalBonusAmount, finalNotes) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const bonusMonth = getBonusMonth(state);
    const districtId = getDistrictId(state);
    const departmentId = getDepartmentId(state);
    const monthBonusState = getMonthBonusState(state);

    await massMonthlyBonusUpdaterApi(
      client,
      bonusMonth,
      districtId,
      departmentId,
      finalBonusAmount,
      finalNotes,
      monthBonusState,
    );
  };
};
